import { render, staticRenderFns } from "./list_subcategories_page.vue?vue&type=template&id=1657fd46&scoped=true"
import script from "./list_subcategories_page.vue?vue&type=script&lang=js"
export * from "./list_subcategories_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1657fd46",
  null
  
)

export default component.exports